<template>
    <v-menu
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                dense
                outlined
                readonly
                hide-details="auto"
                :value="display"
                :label="title"
                v-on="on"
                v-bind="attrs"
                :clearable="clearable"
                @click:clear="date = null"
                class="shrink"
                :disabled="disabled"
                :hint="hint"
                persistent-hint
            ></v-text-field>
        </template>
        <v-date-picker
            v-model="date"
            @input="menu = false"
            :min="min"
            :max="max"
            :type="type"
            :disabled="disabled"
            :active-picker="activePicker"
        ></v-date-picker>
    </v-menu>
</template>

<script>
import { getDateStr } from '@/script/common';

export default {
    props: {
        value: {
            type: String,
        },
        label: {
            type: String,
        },
        min: {
            type: String,
        },
        max: {
            type: String,
        },
        clearable: {
            type: Boolean,
            default: false,
        },
        forMonth: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
        },
        hint: {
            type: String,
        },
        activePicker: {
            type: String
        }
    },
    data() {
        return {
            date: null,
            menu: false,
        };
    },
    mounted() {
        this.date = this.value
            ? getDateStr(this.value, { format: 'yyyy-MM-dd' })
            : null;
    },
    computed: {
        title() {
            return this.label || this.$t('Date');
        },
        display() {
            if (this.date) {
                let dateFormat = this.forMonth ? 'MM/yyyy' : 'dd/MM/yyyy';
                return getDateStr(this.date, { format: dateFormat });
            }
            return null;
        },
        type() {
            return this.forMonth ? 'month' : 'date';
        },
    },
    watch: {
        value(val) {
            if (this.date != val) {
                this.date = getDateStr(val, { format: 'yyyy-MM-dd' });
            }
        },
        date(val) {
            this.$emit('input', val);
        },
    },
};
</script>

<style>
</style>